module.exports = __webpack_public_path__ + "static/img/cursor.aa56178.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cursor.png
// module id = KELv
// module chunks = 1